<template>
  <GcBaseLayout
    :title="title"
    :isXSmall="isXSmall"
    :isLarge="isLarge"
    :baseView="baseView"
    :key="pageKey"
    :backButtonEnable="backButtonRoute ? true : false"
    :backButtonFunction="backButtonFunction"
    :formsConfig="formsConfig"
    :tabs="getTabs"
    :selectedIndex="selectedIndex"
    ref="gc-base-layout"
    class="sales-order-batch-allocations"
  >
    <template #headerContent>
      <GcHeaderContentDynamic
        :title="'Sales Order'"
        :createModeIsEditMode="true"
        :baseView="baseView"
        :primaryLabel="'Sales Order # ' + baseView.id"
        :secondaryLabel="model.CustomerName"
        v-if="loaded"
      />
    </template>

    <div class="css-v2 transaction-screen" v-if="dataloaded">
      <div class="gc-details-grid">
        <dx-data-grid
          @toolbar-preparing="toolbarPreparing($event)"
          :columns="getColumns"
          :data-source="getDataSource"
          :height="getGridHeight"
          :ref="'dx-data-grid-comp'"
          :twoWayBindingEnabled="false"
          :columnChooser="{
            enabled: false,
          }"
          :repaint-changes-only="true"
          :selection="{
            mode: baseView.mode === 'review' ? 'none' : 'multiple',
          }"
          @row-prepared="onMainRowPrepared"
        >
          <DxPaging :page-size="200" :enabled="false" />
          <DxPager :showInfo="false" />

          <DxMasterDetail :enabled="true" template="masterDetailTemplate" />
          <template #masterDetailTemplate="{ data: lineitem }">
            <dx-data-grid
              :columns="getChildColumns"
              :data-source="lineitem.data.ChildDataSource"
              :ref="'master-details-' + lineitem.data.ID"
              :twoWayBindingEnabled="false"
              :columnChooser="{
                enabled: false,
              }"
              :repaint-changes-only="true"
              :selection="{
                mode: baseView.mode === 'review' ? 'none' : 'multiple',
              }"
              @content-ready="onBatchContentReady($event, lineitem)"
              @selection-changed="onBatchSelectionChanged($event, lineitem)"
              @editor-preparing="onBatchEditorPreparing"
              @row-prepared="onBatchRowPrepared"
            >
              <DxPaging :page-size="200" :enabled="false" />
              <DxPager :showInfo="false" />
              <DxSearchPanel :visible="false" />

              <DxEditing
                :allow-deleting="false"
                :allow-updating="baseView.mode != 'review'"
                :mode="'cell'"
              />

              <DxKeyboardNavigation
                :edit-on-key-press="true"
                :enter-key-action="'startEdit'"
                :enter-key-direction="'none'"
                :enabled="true"
              />

              <template #Decimal="{ data }">
                <GcDecimal :dataValue="data" :format="data.column.format" />
              </template>
            </dx-data-grid>
          </template>
        </dx-data-grid>
      </div>
    </div>
  </GcBaseLayout>
</template>

<script>
import RouteMixin from "@/_mixins/route.mixin";
import FormMixin from "@/_mixins/form.mixin";
import { FeatureStorage } from "../../_services/storage";
import { SalesOrderService } from "../../_services/api/sales/sales-order.service";
import { mapGetters } from "vuex";
import ColumnWidth from "../../_helpers/data-grid/ColumnWidth";
import { SalesOrderBatchAllocationsService } from "../../_services/api/sales/sales-order-batch-allocations.service";
import ArrayStore from "devextreme/data/array_store";
import { backwardTabbing, forwardTabbing } from "@/_helpers/ui/keyboard";
import { SalesOrderEDIService } from "../../_services/api/sales/sales-order-edi.service";

export default {
  mixins: [RouteMixin, FormMixin],
  components: {},
  data() {
    return {
      selectedIndex: 1,
      model: {
        CustomerName: null,
        RecordId: undefined,
        IsEDIOrder: undefined,
      },
      loaded: false,
      soDetailsLinesStore: new ArrayStore({
        key: "ID",
        data: [],
      }),
      toExpandRowKeys: [],
      toSelectRowKeys: [],
      dataloaded: false,
      isEditable: true,
      isAllocatedOn: true,
      errorBatchData: [],
      SSCCGenerated: false,
    };
  },
  async created() {
    this.showLoading(true);
    await SalesOrderService.getByCode(this.baseView.id, {
      select: [
        "Code",
        "CustomerCode",
        "Status",
        "RecordId",
        "InvoiceCode",
        "BranchCode",
        "IsEDIOrder",
      ],
    })
      .then(async (res) => {
        if (res.data.value.length > 0) {
          this.model.CustomerName = res.data.value[0].Customer.Name;
          this.model.RecordId = res.data.value[0].RecordId;
          this.model.IsEDIOrder = res.data.value[0].IsEDIOrder;

          if (
            res.data.value[0].Status == "A" &&
            res.data.value[0].InvoiceCode === 0
          ) {
            this.isEditable = true;
          } else this.isEditable = false;

          // await SalesOrderBatchAllocationsService.getBatchAllocationRule(
          //   res.data.value[0].BranchCode
          // ).then((res) => {
          //   if (res.data.value.length > 0) {
          //     if (res.data.value[0].RuleAction === "P") {
          //       this.isAllocatedOn = false;
          //     }
          //   }
          // });
        }
      })
      .catch((err) => {
        if (err) this.showLoading(false);
      });

    SalesOrderEDIService.getSSCCHeader(this.baseView.id, { top: 1 }).then(
      (res) => {
        if (res.data.value.length > 0) {
          this.SSCCGenerated = true;
        }
      }
    );

    if (this.baseView.mode === "edit") await this.getEditScreenItems();
    else await this.getSalesOrderDetailLines();
    this.$nextTick(() => {
      this.loaded = true;
      this.dataloaded = true;
      setTimeout(() => {
        // toExpandRowKeys

        var dataGrid = this.$refs["dx-data-grid-comp"].instance;
        if (dataGrid) {
          this.toExpandRowKeys.forEach((element, index) => {
            setTimeout(() => {
              dataGrid.expandRow(element);
            }, 100 * index);
          });
        }

        this.showLoading(false);
      }, 200);
    });
  },
  methods: {
    backButtonFunction() {
      this.$router
        .push({
          path: this.backButtonRoute,
        })
        .then(() => {
          this.$store.dispatch("dataContext/setDataViewType", undefined);
        });
    },
    async toolbarPreparing(e) {
      var toolbarItems = e.toolbarOptions.items;
      var searchPanel = toolbarItems.find((item) => {
        return item.name === "searchPanel";
      });
      // var columnChooserButton = toolbarItems.find((item) => {
      //   return item.name === "columnChooserButton";
      // });

      let itemsToRemoveFromToolBar = ["searchPanel"];

      e.toolbarOptions.items = toolbarItems.filter(
        (item) => !itemsToRemoveFromToolBar.includes(item.name)
      );

      searchPanel.location = "after";
      e.toolbarOptions.items.unshift(searchPanel, {
        location: "after",
        locateinmenu: "auto",
        widget: "dxButton",
        options: {
          icon: this.baseView.mode === "review" ? "edit" : "floppy",
          onClick: async () => {
            if (this.baseView.mode === "review") {
              this.$router
                .push({
                  path:
                    `/sales-order-batch-allocations/edit/` + this.baseView.id,
                })
                .then(() => {
                  this.toExpandRowKeys = [];
                  this.dataloaded = false;
                  this.showLoading(true);
                  this.$nextTick(async () => {
                    await this.getEditScreenItems();
                    this.$nextTick(() => {
                      this.dataloaded = true;
                      setTimeout(() => {
                        var dataGrid = this.$refs["dx-data-grid-comp"].instance;
                        if (dataGrid) {
                          this.toExpandRowKeys.forEach((element, index) => {
                            setTimeout(() => {
                              dataGrid.expandRow(element);
                            }, 100 * index);
                          });
                        }
                        this.showLoading(false);
                      }, 200);
                    });
                  });
                });
            } else {
              this.saveSOBatchAllocations();
            }
          },
        },
        visible:
          this.isEditable &&
          FeatureStorage.checkPermission("SalesOrder", "create"),
      });
    },
    async getSalesOrderDetailLines() {
      await this.soDetailsLinesStore.clear();
      let BranchCode = undefined;
      await SalesOrderBatchAllocationsService.getSalesOrderDetailsByCode({
        filter:
          "SalesOrderCode eq " +
          this.baseView.id +
          " and IsBatchProduct ne 'No'",
        orderby: "LineNo asc",
      }).then((res) => {
        if (res.data.value.length > 0) {
          res.data.value.forEach(async (element, index) => {
            BranchCode = element.BranchCode;
            element.AllocatedQty = 0;
            element.ChildDataSource = [];
            element.ID = index;
            this.soDetailsLinesStore.insert(element);
          });
        }
      });

      await SalesOrderBatchAllocationsService.getProductBatchAllocation({
        filter: `BranchCode eq '${BranchCode}' and TransactionNo eq ${this.baseView.id} and TransactionType eq 'ISO'`,
      }).then((res) => {
        if (res.data.value.length > 0) {
          res.data.value.forEach((element) => {
            element.AvailableQty = element.Available;
            const lineData = this.soDetailsLinesStore._array.find(
              (x) =>
                x.ItemCode === element.ItemCode &&
                element.TransactionLine === x.LineNo
            );

            if (element.BestBeforeDate)
              element.DisplayDate = new Date(element.BestBeforeDate);

            if (element.UseByDate)
              element.DisplayDate = new Date(element.UseByDate);

            if (lineData) {
              const lineId = lineData.ID;
              lineData.AllocatedQty += element.AllocatedQty;
              lineData.ChildDataSource.push(element);
              this.soDetailsLinesStore.update(lineId, lineData);
              this.toExpandRowKeys.push(lineId);
            }
          });
        }
      });
    },
    async getEditScreenItems() {
      await this.soDetailsLinesStore.clear();
      await SalesOrderBatchAllocationsService.getGetProductionBatchAllocationEdit(
        this.baseView.id
      ).then((res) => {
        if (res.data.TransactionDetails) {
          res.data.TransactionDetails.sort(
            (a, b) => a.TransactionLine - b.TransactionLine
          );
          res.data.TransactionDetails.forEach((element, index) => {
            element.ID = index;
            element.ChildDataSource = new ArrayStore({
              key: "ID",
              data: [],
            });
            element.AllocatedQty = 0;
            element.Description1 = element.ProductDescription1;
            element.SalesUMQty = element.RequiredQty;
            if (element.BatchDetails && element.BatchDetails.length > 0) {
              if (this.isAllocatedOn) this.toExpandRowKeys.push(element.ID);

              element.BatchDetails.forEach((item, index) => {
                item.ParentID = element.ID;
                item.ItemCode = element.ItemCode;
                item.ID = element.ID + "-" + index;

                if (item.BestBeforeDate)
                  item.DisplayDate = new Date(item.BestBeforeDate);

                if (item.UseByDate) item.DisplayDate = new Date(item.UseByDate);

                if (item.Allocate) item.RunSelection = false;

                if (this.isAllocatedOn)
                  item.InTransaction = this.getInTransaction(
                    res.data.TransactionDetails,
                    item
                  );
                else {
                  item.InTransaction = 0;
                  item.AllocatedQty = 0;
                  item.RunSelection = true;
                }

                item.isValid = true;

                item.Remaining = item.AvailableQty - item.InTransaction;
                element.AllocatedQty += item.AllocatedQty;

                element.ChildDataSource.insert(item);
              });
            }
            this.soDetailsLinesStore.insert(element);
          });
        }
      });
    },
    getInTransaction(TransactionDetails, batchLine) {
      const items = TransactionDetails.filter(
        (x) => x.ItemCode === batchLine.ItemCode && x.ID !== batchLine.ParentID
      );

      let InTransaction = 0;
      items.forEach((element) => {
        element.BatchDetails.forEach((batch) => {
          if (batch.BatchNo === batchLine.BatchNo) {
            InTransaction += batch.AllocatedQty;
          }
        });
      });

      return InTransaction;
    },
    onBatchContentReady(e, parentLine) {
      if (this.baseView.mode === "review" || !this.isAllocatedOn) return;

      const allocatedLines = parentLine.data.ChildDataSource._array.filter(
        (x) => x.Allocate === 1
      );
      if (allocatedLines.length > 0) {
        const dataGrid = e.component.instance();

        let batchID = [];
        allocatedLines.forEach((element) => {
          batchID.push(element.ID);
        });
        dataGrid.selectRows(batchID, true);

        var parentDataGrid = this.$refs["dx-data-grid-comp"].instance;
        if (parentDataGrid) {
          parentDataGrid.selectRows([parentLine.data.ID], true);
        }
      }
    },
    onBatchSelectionChanged(e, parentLine) {
      if (this.baseView.mode === "review") return;

      let parentLineData = parentLine.data;

      var parentDataGrid = this.$refs["dx-data-grid-comp"].instance;
      const batchGridInstance = this.getMasterDataInstance(parentLineData.ID);
      let AllocatedQty = 0;
      let rowIndexs = [];

      e.currentSelectedRowKeys.forEach((element) => {
        let batchLine = e.selectedRowsData.find((x) => x.ID === element);

        let Remaining = 0;
        if (batchLine.Remaining) Remaining = batchLine.Remaining;
        else Remaining = batchLine.AvailableQty - batchLine.InTransaction; // - batchLine.AllocatedQty;

        if (batchLine.RunSelection !== false) {
          const remainingAllocation =
            parentLineData.SalesUMQty - parentLineData.AllocatedQty;
          if (remainingAllocation < Remaining)
            AllocatedQty = remainingAllocation;
          else AllocatedQty = Remaining;

          parentLineData.ChildDataSource.update(element, {
            AllocatedQty: AllocatedQty,
            Remaining: batchLine.AvailableQty - batchLine.InTransaction, // - AllocatedQty,
            Allocate: 1,
          }).then((x) => {
            parentLineData.AllocatedQty += x.AllocatedQty;
            let rowIndex = batchGridInstance.getRowIndexByKey(x.ID);
            rowIndexs.push(rowIndex);
            this.updateBatchItemData(x);
          });
        } else {
          setTimeout(() => {
            parentLineData.ChildDataSource.update(element, {
              RunSelection: true,
            });
          }, 1);
        }
      });

      e.currentDeselectedRowKeys.forEach((element) => {
        let batchLine = parentLineData.ChildDataSource._array.find(
          (x) => x.ID === element
        );
        parentLineData.AllocatedQty -= batchLine.AllocatedQty;
        parentLineData.ChildDataSource.update(element, {
          AllocatedQty: 0,
          Allocate: 0,
          Remaining: batchLine.Remaining + batchLine.AllocatedQty,
        }).then((x) => {
          let rowIndex = batchGridInstance.getRowIndexByKey(x.ID);
          rowIndexs.push(rowIndex);
          this.updateBatchItemData(x);
        });
      });

      this.$nextTick(() => {
        this.soDetailsLinesStore
          .update(parentLineData.ID, parentLineData)
          .then((res) => {
            let rowIndex = parentDataGrid.getRowIndexByKey(res.ID);
            parentDataGrid.repaintRows([rowIndex]);
          });

        if (parentDataGrid) {
          parentDataGrid.refresh(true);
          if (batchGridInstance) {
            batchGridInstance.saveEditData();
            batchGridInstance.refresh(true);
            batchGridInstance.repaintRows(rowIndexs);
          }
        }
      });
    },
    onBatchEditorPreparing(e) {
      if (e.editorOptions && e.editorOptions.onKeyDown) {
        let func = e.editorOptions.onKeyDown;
        if (this.baseView.mode != "review" && e.parentType != "searchPanel")
          e.editorOptions.onKeyDown = (event) => {
            func(event, {
              data: e.row,
              component: e.component,
            });
          };
      }
    },
    onMainRowPrepared(e) {
      this.onBatchRowPrepared(e);
    },
    onBatchRowPrepared(e) {
      if (e.rowType === "data") {
        if (e.data.isValid === false && this.baseView.mode !== "review") {
          e.rowElement.classList.add("alert-row");
          if (e.rowElement.classList.contains("dx-row-alt")) {
            e.rowElement.classList.add("dx-row-alt-back");
            e.rowElement.classList.remove("dx-row-alt");
          }
        } else {
          e.rowElement.classList.remove("alert-row");
          if (e.rowElement.classList.contains("dx-row-alt-back")) {
            e.rowElement.classList.remove("dx-row-alt-back");
            e.rowElement.classList.add("dx-row-alt");
          }
        }
      }
    },

    /**
     *
     * @param id
     * @returns {*}
     */
    getMasterDataInstance(id) {
      if (this.$refs["master-details-" + id])
        return this.$refs["master-details-" + id].instance;
      else return false;
    },
    reFocusOnChildGrid(dataField, lineData) {
      const batchGridInstance = this.getMasterDataInstance(lineData.ParentID);

      var rowIndex = batchGridInstance.getRowIndexByKey(lineData.ID);
      var cell = batchGridInstance.getCellElement(rowIndex, dataField);
      batchGridInstance.editCell(rowIndex, dataField);

      setTimeout(() => {
        this.$nextTick(() => {
          batchGridInstance.focus(cell);
        });
      }, 500);
    },
    updateBatchItemData(batchLine) {
      const items = this.soDetailsLinesStore._array.filter(
        (x) => x.ItemCode === batchLine.ItemCode
      );

      items.forEach((element) => {
        if (
          element.ItemCode === batchLine.ItemCode &&
          element.ID === batchLine.ParentID
        )
          return;

        element.ChildDataSource._array.forEach((batch) => {
          let inTransit = 0;
          const valueItems = this.soDetailsLinesStore._array.filter(
            (x) => x.ItemCode === batchLine.ItemCode && x.ID !== batch.ParentID
          );

          valueItems.forEach((vItem) => {
            vItem.ChildDataSource._array.forEach((item) => {
              if (item.BatchNo === batch.BatchNo && item.AllocatedQty > 0) {
                inTransit += item.AllocatedQty;
              }
            });
          });

          element.ChildDataSource.update(batch.ID, {
            InTransaction: inTransit,
            Remaining: batch.AvailableQty - inTransit, // - batch.AllocatedQty,
          }).then((res) => {
            const batchGridInstance = this.getMasterDataInstance(res.ParentID);

            if (batchGridInstance) {
              let rowIndex = batchGridInstance.getRowIndexByKey(res.ID);
              batchGridInstance.repaintRows([rowIndex]);
            }
          });
        });
      });
    },
    // onAllocatedQtyKeyDown(e, cellInfo) {
    //   if (e.event && forwardTabbing(e)) {
    //     let data = cellInfo.data.data;
    //     let gridInstance = this.$refs["dx-data-grid-comp"].instance;
    //     let batchGridInstance = cellInfo.component;

    //     let items = batchGridInstance.getDataSource().items();
    //     let rowIndex = cellInfo.data.rowIndex;
    //     if (rowIndex === items.length - 1) {
    //       e.event.preventDefault();
    //       batchGridInstance.option("focusedRowIndex", -1);

    //       var gridDS = gridInstance.getDataSource();
    //       var loadOptions = gridDS.loadOptions();
    //       gridDS
    //         .store()
    //         .load(loadOptions)
    //         .done((loadedItems) => {
    //           let parentRowIndex = loadedItems.findIndex(
    //             (x) => x.ID == data.ParentID
    //           );
    //           let nextRowIndex = parentRowIndex + 1;

    //           let nextRow = loadedItems[nextRowIndex];

    //           setTimeout(() => {
    //             if (nextRow) {
    //               if (nextRow.BatchDetails && nextRow.BatchDetails.length > 0) {
    //                 this.focusOnEditingCell(nextRow, 0);
    //               } else {
    //                 const next = this.getNextRowToTabin(
    //                   loadedItems,
    //                   nextRowIndex
    //                 );

    //                 if (next) this.focusOnEditingCell(next, 0);
    //               }
    //             }
    //           }, 10);
    //         });
    //     }
    //   }

    //   if (e.event && backwardTabbing(e)) {
    //     let data = cellInfo.data.data;
    //     let gridInstance = this.$refs["dx-data-grid-comp"].instance;
    //     let batchGridInstance = cellInfo.component;

    //     let items = batchGridInstance.getDataSource().items();
    //     let rowIndex = cellInfo.data.rowIndex;

    //     if (rowIndex === 0) {
    //       e.event.preventDefault();
    //       batchGridInstance.option("focusedRowIndex", -1);

    //       var gridDS = gridInstance.getDataSource();
    //       var loadOptions = gridDS.loadOptions();
    //       gridDS
    //         .store()
    //         .load(loadOptions)
    //         .done((loadedItems) => {
    //           let parentRowIndex = loadedItems.findIndex(
    //             (x) => x.ID == data.ParentID
    //           );
    //           let prevRowIndex = parentRowIndex - 1;

    //           if (prevRowIndex >= 0) {
    //             let prevRow = loadedItems[prevRowIndex];
    //             setTimeout(() => {
    //               if (prevRow) {
    //                 if (
    //                   prevRow.BatchDetails &&
    //                   prevRow.BatchDetails.length > 0
    //                 ) {
    //                   this.focusOnEditingCell(
    //                     prevRow,
    //                     prevRow.BatchDetails.length - 1
    //                   );
    //                 } else {
    //                   const next = this.getPrevRowToTabin(
    //                     loadedItems,
    //                     prevRowIndex
    //                   );

    //                   if (next)
    //                     this.focusOnEditingCell(
    //                       next,
    //                       next.BatchDetails.length - 1
    //                     );
    //                 }
    //               }
    //             }, 10);
    //           }
    //         });
    //     }
    //   }
    // },

    onAllocatedQtyKeyDown(e, cellInfo) {
      if (e.event) {
        const isForward = forwardTabbing(e);
        const isBackward = backwardTabbing(e);

        if (isForward || isBackward) {
          let data = cellInfo.data.data;
          let gridInstance = this.$refs["dx-data-grid-comp"].instance;
          let batchGridInstance = cellInfo.component;
          let items = batchGridInstance.getDataSource().items();
          let rowIndex = cellInfo.data.rowIndex;

          if (
            (isForward && rowIndex === items.length - 1) ||
            (isBackward && rowIndex === 0)
          ) {
            e.event.preventDefault();
            batchGridInstance.option("focusedRowIndex", -1);

            let gridDS = gridInstance.getDataSource();
            let loadOptions = gridDS.loadOptions();

            gridDS
              .store()
              .load(loadOptions)
              .done((loadedItems) => {
                let parentRowIndex = loadedItems.findIndex(
                  (x) => x.ID == data.ParentID
                );
                let nextRowIndex = isForward
                  ? parentRowIndex + 1
                  : parentRowIndex - 1;

                if (nextRowIndex >= 0 && nextRowIndex < loadedItems.length) {
                  let targetRow = loadedItems[nextRowIndex];
                  setTimeout(
                    () =>
                      this.navigateToRow(
                        targetRow,
                        loadedItems,
                        nextRowIndex,
                        isForward
                      ),
                    10
                  );
                }
              });
          }
        }
      }
    },

    navigateToRow(row, loadedItems, rowIndex, isForward) {
      if (row) {
        if (row.BatchDetails && row.BatchDetails.length > 0) {
          const cellIndex = isForward ? 0 : row.BatchDetails.length - 1;
          this.focusOnEditingCell(row, cellIndex);
        } else {
          const nextRow = isForward
            ? this.getNextRowToTabin(loadedItems, rowIndex)
            : this.getPrevRowToTabin(loadedItems, rowIndex);

          if (nextRow) {
            const cellIndex = isForward ? 0 : nextRow.BatchDetails.length - 1;
            this.focusOnEditingCell(nextRow, cellIndex);
          }
        }
      }
    },
    getNextRowToTabin(loadedItems, nextRowIndex) {
      let next = false;

      if (loadedItems.length > nextRowIndex + 1) {
        next = loadedItems[nextRowIndex + 1];
        if (next && next.BatchDetails && next.BatchDetails.length > 0) {
          return next;
        } else this.getNextRowToTabin(loadedItems, nextRowIndex + 1);
      } else return next;
    },
    getPrevRowToTabin(loadedItems, prevRowIndex) {
      let prev = false;

      if (loadedItems.length > prevRowIndex + 1) {
        prev = loadedItems[prevRowIndex - 1];
        if (prev && prev.BatchDetails && prev.BatchDetails.length > 0) {
          return prev;
        } else this.getPrevRowToTabin(loadedItems, prevRowIndex - 1);
      } else return prev;
    },

    focusOnEditingCell(nextRow, rowIndex) {
      setTimeout(() => {
        let mainGridInstance = this.$refs["dx-data-grid-comp"].instance;
        mainGridInstance.expandRow(nextRow.ParentID).then(() => {
          let gridInstance = this.getMasterDataInstance(nextRow.ID);
          if (gridInstance) {
            let cellElement = gridInstance.getCellElement(
              rowIndex,
              "AllocatedQty"
            );

            if (cellElement) {
              gridInstance.focus(cellElement);
              setTimeout(() => {
                gridInstance.editCell(rowIndex, "AllocatedQty");
              }, 1);
            }
          }
        });
      }, 50);
    },

    async saveSOBatchAllocations() {
      let errorSalesLines = [];

      this.showLoading(true);
      let payload = {
        TransactionType: "ISO",
        TransactionNo: this.baseView.id,
        TransactionID: this.model.RecordId,
        ProductBatchAllocationBatches: [],
      };
      this.soDetailsLinesStore._array.forEach((element) => {
        element.ChildDataSource._array.forEach((batch) => {
          if (batch.AllocatedQty > 0) {
            payload.ProductBatchAllocationBatches.push({
              Allocate: 1,
              TransactionType: "ISO",
              TransactionNo: this.baseView.id,
              TransactionLine: element.TransactionLine,
              ItemCode: element.ItemCode,
              // ProcessCode: "string",
              SupplierCode: batch.SupplierCode,
              SupplierName: batch.SupplierName,
              BatchNo: batch.BatchNo,
              SalesUMAllocatedQty: batch.AllocatedQty,
              SalesUMAvailableQty: batch.AvailableQty,
            });
          }
        });

        this.soDetailsLinesStore.update(element.ID, {
          isValid: true,
        });

        if (this.SSCCGenerated && element.SalesUMQty != element.AllocatedQty) {
          errorSalesLines.push(element.ID);
        }
      });

      if (errorSalesLines.length > 0) {
        this.showLoading(false);
        await this.$alert(
          "One or more sales order line has incomplete batch allocation, please complete the batch allocation for all the sales order lines",
          "Validation Error"
        );

        this.showLoading(true);

        let repaintRowIndex = [];
        errorSalesLines.forEach((key) => {
          this.soDetailsLinesStore
            .update(key, {
              isValid: false,
            })
            .then((res) => {
              var dataGrid = this.$refs["dx-data-grid-comp"].instance;
              if (dataGrid) {
                let rowIndex = dataGrid.getRowIndexByKey(res.ID);
                if (rowIndex != -1) {
                  const check = repaintRowIndex.findIndex(
                    (x) => x === rowIndex
                  );
                  if (check === -1) repaintRowIndex.push(rowIndex);
                }
              }
            });
        });

        this.showLoading(false);
        this.$nextTick(() => {
          repaintRowIndex.forEach((element) => {
            var dataGrid = this.$refs["dx-data-grid-comp"].instance;
            if (dataGrid) {
              dataGrid.repaintRows([element]);
            }
          });
        });
      } else {
        await SalesOrderBatchAllocationsService.saveBatchAllocation(payload)
          .then(async () => {
            if (this.SSCCGenerated) {
              await SalesOrderEDIService.SaveProcessEDISalesOrder(
                this.baseView.id
              )
                .then(async () => {
                  this.showLoading(false);
                })
                .catch((err) => {
                  this.showLoading(false);
                  this.displayServerError(err);
                });
            } else this.showLoading(false);

            this.$notify(`Batch Allocation Successfully Saved`, "success");

            this.setIgnoreRouteChangeConfirmation();
            this.$router
              .push({
                path:
                  `/sales-order-batch-allocations/review/` + this.baseView.id,
              })
              .then(async () => {
                this.toExpandRowKeys = [];
                this.dataloaded = false;
                this.showLoading(true);
                this.$nextTick(async () => {
                  await this.getSalesOrderDetailLines();
                  this.$nextTick(() => {
                    this.dataloaded = true;
                    setTimeout(() => {
                      var dataGrid = this.$refs["dx-data-grid-comp"].instance;
                      if (dataGrid) {
                        this.toExpandRowKeys.forEach((element, index) => {
                          setTimeout(() => {
                            dataGrid.expandRow(element);
                          }, 100 * index);
                        });
                      }
                      this.showLoading(false);
                    }, 200);
                  });
                });
              });
          })
          .catch(async (err) => {
            this.showLoading(false);
            if (
              err &&
              err.data &&
              err.data.ValidationErrors &&
              err.data.ValidationErrors.length > 0
            ) {
              err.data.ValidationErrors.forEach((element) => {
                if (element.BatchNo && element.ItemCode) {
                  this.errorBatchData.push({
                    BatchNo: element.BatchNo,
                    ItemCode: element.ItemCode,
                  });
                }
              });

              await this.$alert(
                "One or more batch lines do not have sufficient quantity to proceed with the batch allocation. Please update the highlighted lines and try again.",
                "Server Error"
              );

              this.showLoading(true);
              this.refreshBatchData();
            } else {
              this.$notify(`Batch Allocation Failed`, "error");
            }
          });
      }
    },
    async refreshBatchData() {
      await SalesOrderBatchAllocationsService.getGetProductionBatchAllocationEdit(
        this.baseView.id
      )
        .then((res) => {
          let repaintBatchRowIndex = [];
          // eslint-disable-next-line no-unused-vars

          if (res.data.TransactionDetails)
            res.data.TransactionDetails.forEach((element) => {
              this.errorBatchData.forEach((item) => {
                if (item.ItemCode === element.ItemCode) {
                  const batchInfo = element.BatchDetails.find(
                    (b) => b.BatchNo === item.BatchNo
                  );
                  if (batchInfo) {
                    const dataItems = this.soDetailsLinesStore._array.filter(
                      (i) => i.ItemCode === item.ItemCode
                    );
                    dataItems.forEach((dataItem) => {
                      dataItem.ChildDataSource._array.forEach((childBatch) => {
                        if (childBatch.BatchNo === item.BatchNo) {
                          dataItem.ChildDataSource.update(childBatch.ID, {
                            isValid: childBatch.AllocatedQty > 0 ? false : true,
                            Available: batchInfo.AvailableQty,
                            AvailableQty: batchInfo.AvailableQty,
                            Remaining:
                              batchInfo.AvailableQty - childBatch.InTransaction,
                          }).then((res) => {
                            let batchGridInstance = this.getMasterDataInstance(
                              res.ParentID
                            );

                            if (batchGridInstance) {
                              let rowIndex = batchGridInstance.getRowIndexByKey(
                                res.ID
                              );

                              if (rowIndex != -1) {
                                const check = repaintBatchRowIndex.findIndex(
                                  (x) =>
                                    x.ParentID === res.ParentID &&
                                    x.rowIndex === rowIndex
                                );
                                if (check === -1)
                                  repaintBatchRowIndex.push({
                                    ParentID: res.ParentID,
                                    rowIndex: rowIndex,
                                  });
                              }
                            }
                            // parentDataGrid.repaintRows([rowIndex]);
                          });
                        }
                      });
                    });
                  }
                }
              });
            });

          this.showLoading(false);
          this.$nextTick(() => {
            repaintBatchRowIndex.forEach((element) => {
              let batchGridInstance = this.getMasterDataInstance(
                element.ParentID
              );
              if (batchGridInstance)
                batchGridInstance.repaintRows([element.rowIndex]);
            });
          });
        })
        .catch((err) => {
          if (err) this.showLoading(false);
          this.$notify(`Batch Items Refetch Failed`, "error");
        });
    },
  },
  computed: {
    ...mapGetters({ gridHeight: "ui/getHeightForDataGrid" }),
    getTabs() {
      var tabItems = [];

      if (this.baseView.mode !== "create") {
        tabItems = [
          {
            text: "Order",
            path: `/sales-order/review/${this.baseView.id}`,
            applicationFeatureCode: "SalesOrder",
          },
          {
            text: "Batch Allocation",
            path: `/sales-order-batch-allocations/${this.baseView.mode}/${this.baseView.id}`,
            applicationFeatureCode: "SalesOrder",
          },
          {
            text: "EDI",
            path: `/sales-order-edi/${this.baseView.id}`,
            applicationFeatureCode: "SalesOrderEDI",
            disabled: this.model.IsEDIOrder === "N",
          },
          {
            text: "Lot Assignment",
            path: `/almondco-inshell-sales-order-lot-assignment/review/${this.baseView.id}`,
            applicationFeatureCode: "AlmondcoInshellSalesOrderLotAssignment",
            visible: FeatureStorage.checkPermission(
              "AlmondcoInshellSalesOrderLotAssignment",
              "review"
            ),
          },
        ];
      }

      return tabItems;
    },
    backButtonRoute() {
      return "/sales-order";
    },
    getGridHeight() {
      return this.gridHeight - 20; // - 40;// - 55;
      // 20 => Top & Bottom Padding
      // 40 => Footer Height
      // 55 => Toolbar Height + Toolbar bottom padding
    },
    getColumns() {
      return [
        {
          caption: "",
          dataField: "",
          type: "detailExpand",
          fixed: true,
          fixedPosition: "left",
          visibleIndex: 0,
          width: 30,
          minWidth: 30,
        },
        {
          caption: "",
          dataField: "",
          type: "selection",
          fixed: true,
          fixedPosition: "left",
          visibleIndex: 1,
          visible: this.baseView.mode !== "review",
        },
        {
          caption: "Product / Account",
          dataField: "Description",
          // sortOrder: "asc",
          // sortIndex: 0,
          // cssClass: "class-item-cell-template",
          cellTemplate: (data, info) => {
            return (data.innerHTML = `<div class="custom-auto-complete" @click="clickOnInfo(${info})">
                        <span class="auto-complete-primary">
                          ${info.data.Description1}
                        </span>
                        <span class="record-secondary gc-grid-code">
                          ${info.data.ItemCode}
                        </span>
                      </div>`);
          },
          allowEditing: false,
          minWidth: 420,
          // tabindex: -1,
        },
        {
          caption: "UM",
          dataField: "SalesUM",
          allowEditing: false,
          allowSorting: false,
          width: ColumnWidth.UnitOfMeasure.width,
          maxWidth: ColumnWidth.UnitOfMeasure.minWidth,
        },
        {
          caption: "Order Quantity",
          dataField: "SalesUMQty",
          allowEditing: false,
          format: "##,###,###,###,##0.0000",
          dataType: "number",
          width: ColumnWidth.Quantity4DecimalPoints.width,
          maxWidth: ColumnWidth.Quantity4DecimalPoints.minWidth,
        },
        {
          caption: "Allocated Qty",
          dataField: "AllocatedQty",
          allowEditing: false,
          format: "##,###,###,###,##0.0000",
          dataType: "number",
          width: ColumnWidth.Quantity4DecimalPoints.width,
          maxWidth: ColumnWidth.Quantity4DecimalPoints.minWidth,
        },
      ];
    },
    getDataSource() {
      return this.soDetailsLinesStore;
    },
    getChildColumns() {
      return [
        {
          caption: "Batch",
          dataField: "BatchNo",
          allowEditing: false,
          width: ColumnWidth.BatchNo.width,
          maxWidth: ColumnWidth.BatchNo.minWidth,
        },
        {
          caption: "Supplier",
          dataField: "SupplierCode",
          cellTemplate: (data, info) => {
            return (data.innerHTML = `<div class="custom-auto-complete" @click="clickOnInfo(${info})">
                        <span class="auto-complete-primary">
                          ${info.data.SupplierName}
                        </span>
                        <span class="record-secondary gc-grid-code">
                          ${info.data.SupplierCode}
                        </span>
                      </div>`);
          },
          allowEditing: false,
        },
        {
          caption: "Use By / Best Before",
          dataField: "DisplayDate",
          width: ColumnWidth.Date.width + 30,
          maxWidth: ColumnWidth.Date.minWidth + 30,
          format: "dd MMM yyyy",
          type: "date",
        },
        {
          caption: "Available",
          dataField: "AvailableQty",
          format: "##,###,###,###,##0.0000",
          dataType: "number",
          width: ColumnWidth.Quantity4DecimalPoints.width,
          maxWidth: ColumnWidth.Quantity4DecimalPoints.minWidth,
          cellTemplate: "Decimal",
          allowEditing: false,
        },
        {
          caption: "In Transaction",
          dataField: "InTransaction",
          format: "##,###,###,###,##0.0000",
          dataType: "number",
          width: ColumnWidth.Quantity4DecimalPoints.width,
          maxWidth: ColumnWidth.Quantity4DecimalPoints.minWidth,
          cellTemplate: "Decimal",
          allowEditing: false,
          visible: this.baseView.mode != "review",
        },
        {
          caption: "Remaining",
          dataField: "Remaining",
          format: "##,###,###,###,##0.0000",
          dataType: "number",
          width: ColumnWidth.Quantity4DecimalPoints.width,
          maxWidth: ColumnWidth.Quantity4DecimalPoints.minWidth,
          cellTemplate: "Decimal",
          allowEditing: false,
          visible: this.baseView.mode != "review",
        },
        {
          caption: "Allocated Qty",
          dataField: "AllocatedQty",
          format: "##,###,###,###,##0.0000",
          dataType: "number",
          width: ColumnWidth.Quantity4DecimalPoints.width,
          maxWidth: ColumnWidth.Quantity4DecimalPoints.minWidth,
          cellTemplate: "Decimal",
          allowEditing: true,
          cssClass: "edit-cell-numberbox-field",
          editorOptions: {
            format: "##,###,###,###,##0.0000",
            min: 0,
            onFocusIn: (e) => {
              e.event.target.select();
            },
            onKeyDown: this.onAllocatedQtyKeyDown,
          },
          setCellValue: async (newData, value, currentRowData) => {
            var parentDataGrid = this.$refs["dx-data-grid-comp"].instance;
            const batchGridInstance = this.getMasterDataInstance(
              currentRowData.ParentID
            );

            if (value === 0) {
              batchGridInstance.deselectRows([currentRowData.ID]);
              newData.AllocatedQty = 0;

              this.$nextTick(() => {
                this.updateBatchItemData({ ...currentRowData, ...newData });
              });
            } else {
              let AllocatedQty = 0;
              let parentLine = undefined;

              parentDataGrid.byKey(currentRowData.ParentID).then((res) => {
                res.AllocatedQty -= currentRowData.AllocatedQty;

                const remainingAllocation = res.SalesUMQty - res.AllocatedQty;

                if (
                  remainingAllocation <
                  currentRowData.Remaining + +currentRowData.AllocatedQty
                )
                  AllocatedQty = remainingAllocation;
                else
                  AllocatedQty =
                    currentRowData.Remaining + currentRowData.AllocatedQty;

                parentLine = res;
              });

              if (
                currentRowData.Remaining > 0 &&
                value > currentRowData.Remaining + currentRowData.AllocatedQty
              ) {
                await this.$alert(
                  `${
                    currentRowData.BatchNo
                  } has an allocated quantity of ${value}, which is greater than the batch remaining quantity of ${
                    currentRowData.Remaining + currentRowData.AllocatedQty
                  }.
                  Please update the batch allocated quantity so that is less than or equal to the ${
                    currentRowData.Remaining + currentRowData.AllocatedQty
                  }.`,
                  "Warning"
                );
                newData.AllocatedQty = currentRowData.AllocatedQty;
                setTimeout(() => {
                  this.reFocusOnChildGrid("AllocatedQty", currentRowData);
                }, 100);
              } else if (value > AllocatedQty) {
                await this.$alert(
                  `${currentRowData.BatchNo} has an allocated quantity of ${value}, which is greater than the Product Remaining Unallocated Qty of ${AllocatedQty}.
                  Please update the batch allocated quantity so that is less than or equal to the ${AllocatedQty}`
                );
                newData.AllocatedQty = currentRowData.AllocatedQty;
                setTimeout(() => {
                  this.reFocusOnChildGrid("AllocatedQty", currentRowData);
                }, 100);
              } else {
                newData.AllocatedQty = value;
                newData.Remaining =
                  currentRowData.AvailableQty - currentRowData.InTransaction; // - value;
                newData.RunSelection = false;

                parentLine.ChildDataSource.update(
                  currentRowData.ID,
                  newData
                ).then(() => {
                  this.$nextTick(() => {
                    batchGridInstance.selectRows([currentRowData.ID], true);
                  });
                });
              }

              parentLine.AllocatedQty += newData.AllocatedQty;

              this.soDetailsLinesStore
                .update(parentLine.ID, parentLine)
                .then((res) => {
                  let rowIndex = parentDataGrid.getRowIndexByKey(res.ID);
                  parentDataGrid.repaintRows([rowIndex]);
                });

              if (parentDataGrid) {
                parentDataGrid.refresh(true);
              }

              let rowIndex = batchGridInstance.getRowIndexByKey(
                currentRowData.ID
              );

              if (batchGridInstance) {
                batchGridInstance.repaintRows([rowIndex]);
              }

              this.updateBatchItemData({ ...currentRowData, ...newData });

              return newData;
            }
          },
        },
      ];
    },
  },
};
</script>

<style lang="scss">
.sales-order-batch-allocations {
  .css-v2
    .dx-datagrid.dx-gridbase-container
    .dx-datagrid-rowsview
    .dx-row.dx-data-row
    td.edit-cell-numberbox-field {
    padding-left: 5px !important;
    padding-right: 5px !important;
  }

  .alert-row {
    background-color: #ffcccc; /* Light red background */
    color: #a94442; /* Dark red text */
  }

  .dx-datagrid-headers[role="presentation"] {
    padding-right: unset !important;
  }

  div.dx-datagrid-content.dx-datagrid-content-fixed {
    margin-right: unset !important;
  }

  // .dx-datagrid
  //   .dx-datagrid-content
  //   .dx-datagrid-table
  //   .dx-row
  //   > td:first-of-type:not(.dx-command-expand) {
  //   // padding-left: unset !important;
  // }

  .dx-datagrid-table.dx-datagrid-table-fixed {
    td.dx-master-detail-cell {
      padding-right: unset !important;
    }
  }

  // .dx-row.dx-row-lines.dx-master-detail-row {
  //   td.dx-master-detail-cell {
  //     // padding-right: unset !important;
  //   }
  // }

  // dx-datagrid-table dx-pointer-events-none dx-datagrid-table-fixed

  // dx-datagrid-rowsview dx-fixed-columns dx-scrollable dx-visibility-change-handler dx-scrollable-both dx-scrollable-native dx-scrollable-native-generic
  // dx-datagrid-table dx-datagrid-table-fixed
}
</style>
